/**
 * Globales Toast-System. Exakt gleicher Stil wie die Dashboard-Job-Phasen-Meldungen.
 * Erscheint unten rechts (Desktop) / über Nav-Bar (Mobile).
 * Gleiche Meldung ersetzt sich selbst statt zu stapeln.
 *
 * Anzeigedauer nach Textlänge (`calcNoticeDisplayMs`). Hover/Touch hält die Meldung an,
 * Antippen schließt sie sofort.
 */

import { calcNoticeDisplayMs, NOTICE_FADE_MS } from './notice-duration.js';

let currentToast: HTMLDivElement | null = null;
let fadeTimer:    ReturnType<typeof setTimeout> | null = null;
let removeTimer:  ReturnType<typeof setTimeout> | null = null;

function clearTimers(): void {
  if (fadeTimer   !== null) { clearTimeout(fadeTimer);   fadeTimer   = null; }
  if (removeTimer !== null) { clearTimeout(removeTimer); removeTimer = null; }
}

function removeToast(): void {
  clearTimers();
  currentToast?.remove();
  currentToast = null;
}

function startTimers(displayMs: number): void {
  clearTimers();
  fadeTimer = setTimeout(() => {
    currentToast?.classList.add('toast--fade');
    fadeTimer = null;
  }, displayMs - NOTICE_FADE_MS);
  removeTimer = setTimeout(removeToast, displayMs);
}

export function showToast(message: string, type: 'info' | 'error' = 'info'): void {
  const displayMs = calcNoticeDisplayMs(message, type === 'error');

  // Bestehendes Toast recyclen oder neues erstellen
  if (currentToast !== null) {
    currentToast.className   = `toast toast--${type}`;
    currentToast.textContent = message;
  } else {
    const t = document.createElement('div');
    t.className   = `toast toast--${type}`;
    t.textContent = message;
    t.title       = 'Antippen zum Schließen';
    t.addEventListener('click', removeToast);
    // Beim Lesen (Maus drauf) anhalten, beim Verlassen neu starten
    t.addEventListener('mouseenter', () => {
      clearTimers();
      t.classList.remove('toast--fade');
    });
    t.addEventListener('mouseleave', () => {
      startTimers(calcNoticeDisplayMs(t.textContent,t.classList.contains('toast--error')));
    });
    document.body.appendChild(t);
    currentToast = t;
  }

  startTimers(displayMs);
}
